import { Api, Config } from './api'

export const ApiObterGrupoUsuarioAtributos = async () => {
   const { data } = await Api.get(`/grupo-usuario-atributo?ordenar=descricao`, Config())

   return data
}
